<template>
  <div>
    <v-row>

      <v-col cols="6">
        <v-card>
          <v-card-title>
            سال مالی
          </v-card-title>
          <v-card-text>

            <v-row>
              <strong class="error--text">در صورت ساخت سال مالی، تعاریف سال مالی فعال، به سال مالی جدید انتقال داده خواهند شد</strong>
            <br>
            </v-row>
            <v-row>
              <date-picker
                      type="year"
                  format="jYYYY"
                  display-format="jYYYY"
                  label="ایجاد سال مالی"
                  :editable="false"
                  :auto-submit="false"
                  v-model="accounting_year"
                  @change="input_date_year($event)"
              />
            </v-row>
            <v-row>
              <v-btn
                     @click="insert_data()"
                     outlined small color="warning">
                ایجاد سال مالی
              </v-btn>
            </v-row>
            <hr>
            <div class="container">
              <v-row>
                <strong class="error--text">در صورت تغییر سال مالی فاکتور ها فقط در همان سال ثبت خواهند شد</strong>
                <br>
              </v-row>
              <div class="row ">
                <v-data-table
                        dense
                        hide-default-footer
                        height="400"
                        fixed-header
                        disable-pagination
                        multi-sort
                        class="margin-auto table-bordered"
                        :headers="headers"
                        :items="year_list"
                >
                  <template v-slot:item.operation="{ item }">

                    <v-btn
                           @click="active_year(item)"
                           v-if="item.is_active==0"
                           outlined small color="warning">
                      <v-icon
                              small
                              color="warning"
                      >
                        mdi-check
                      </v-icon>
                      فعال کردن
                    </v-btn>

                  </template>


                  <template v-slot:item.is_active="{ item }">
                    <label v-if="item.is_active==1">فعال</label>
                    <label v-if="item.is_active==0">غیر فعال</label>
                  </template>

                </v-data-table>
              </div>
            </div>

          </v-card-text>
          <v-card-actions>
            <v-btn  color="warning" id="edit_address" @click="insert_data()">ویرایش
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Vue from 'vue'
import { bus } from '../main'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker/src/VuePersianDatetimePicker'

export default {
  name: 'OriginDownload',
  components: {
    datePicker: VuePersianDatetimePicker

  },
  data () {
    return {
      confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
      items: [],
      status_form: 0,
      accounting_year:'',
      year_list:[],
      headers: [

        {
          text: 'سال مالی',
          value: 'year'
        },
        {
          text: 'وضعیت',
          value: 'is_active'
        },
        {
          text: 'عملیات',
          value: 'operation'
        },

      ]

    }
  },
  mounted () {
    this.get_data()
  },
  methods: {
    input_date_year(e){
      console.log("input year date called",e.format('dddd jDD jMMMM jYYYY'))
    },
    get_data () {
      var self = this
      const formData = new FormData()
      // formData.append('id', this.selected_province);
      this.axios.post('/api/settings/get_fiscal_year', formData, {}).then(function (response) {
        //
        //
        // items = content_cats.orders;
        // if (response.data.error == 0) {

          self.year_list = response.data
        // } else {
        //   self.$root.modal_component.show_danger_modal('خطا', response.data.msg)
        //
        // }

      }).catch(function (error) {
        self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

        console.log(error)
      })

    },
    active_year (item) {
      var self = this
      const formData = new FormData()
      // formData.append('id', this.selected_province);
      var url = '/api/settings/change_active_fiscal_year'

      formData.append('id', item.id)

      this.axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response)

        // items = content_cats.orders;
        if (response.data.error == 0) {
          self.get_data()
        }
      }).catch(function (error) {
        self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

        console.log(error)
      })

    },
    insert_data () {
      var self = this
      const formData = new FormData()
      // formData.append('id', this.selected_province);
      var url = '/api/settings/add_fiscal_year'

     formData.append('year', this.accounting_year)

      this.axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response)

        // items = content_cats.orders;
        if (response.data.error == 0) {
          self.get_data()
        }
      }).catch(function (error) {
        self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

        console.log(error)
      })

    },

  }
}
</script>
